import { render, staticRenderFns } from "./waveChart.vue?vue&type=template&id=18ca3ef0&scoped=true"
import script from "./waveChart.vue?vue&type=script&lang=js"
export * from "./waveChart.vue?vue&type=script&lang=js"
import style0 from "./waveChart.vue?vue&type=style&index=0&id=18ca3ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ca3ef0",
  null
  
)

export default component.exports